import { useEffect, useRef, useState } from "react";

import moment from "moment";
import queryString from "query-string";
import { toast } from "react-toastify";
import { Button, Modal } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import {
  matchPath,
  Outlet,
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";

import {
  faMailBulk,
  faMailForward,
  faMailReply,
  faPaperPlane,
  faPlane,
  faRepeat,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";


import DataTable from "../../common/components/DataTable";
import useDataCountry from "../../../hooks/useDataCountry";
import FilterView from "../../common/components/FilterView";
import OblDetails from "../../common/components/OblDetails";
import { IConfigsDefinition } from "../../utils/columnConfig";
import { AESDecrypt, AESEncrypt } from "../../../encrypt-util";
import { IDataTableColumn } from "../../common/types/dataTable";
import { getColumnViews } from "../../common/actions/dataTable";

import { getDashboardData } from "../dashboard/actions/dashboard";
import { updateDashbaordName } from "../../common/slices/navbarTop";
import { updateCurrentPagePayment } from "../dashboard/slices/dashboardSlice";
import DashboardContainer from "../../../components/common/DashboardContainer";
import { useGenerateColumnConfig } from "../../../hooks/useGenerateColumnConfig";
import {
  updateDashbaordRefresh,
  updateParams,
  updateSortStateDataTable,
} from "../../common/components/DataTable/slices/DataTable";
import { mergePayment, sendMailToLiner } from "../blPayment/actions/payments";
import { faCreditCard } from "@fortawesome/free-regular-svg-icons";
import {
  updateSelectedAmountPayment,
  updateSelectedpaymentMultiPayTable,
  updateSelectedRowsInvoice,
  updateSelectedRowsPayment,
} from "../multiBlPayment/slices/multiBlPaymentSlice";
import { toggleColumnSettingsPaymentList } from "../payment/paymentSlice";
import { AppDispatch, RootState } from "../template/store";
import { toggleColumnSettingsPayDash } from "../paymentdashboard/paymntDashSlice";

const gridName = "BULK_PAYMENT_PROCESS_CONFIG";
const dashboardName = "BULKPAYMENT_DASHBOARD";
const BulkPaymentDashboard = () => {
  const { blNum } = useParams();

  const navigate = useNavigate();

  const dispatch = useDispatch<AppDispatch>();
  const location = useLocation();
  const [columns, setColumns] = useState<IDataTableColumn[]>([]);
  const [configs, setConfigs] = useState<IConfigsDefinition>({
    columns: [],
    staticHiddenCols: [],
    defaultHiddenCols: [],
  });
  //const [selectedPayment, setSelectedPayment] = useState<any>(null);

  const paymentDetailsCheckboxAccess =
    useSelector((state: RootState) => state.userProfile)?.rbacDetails
      ?.paymentDetailsCheckboxAccess ?? "N";
  const refresh = useSelector(
    (state: RootState) => state.dataTable.refreshDashboard
  );
  const selectionInitialState = useSelector(
    (state: RootState) => state.multiBlPayment.selectedRowsPaymentMultiPayTable
  );
  const currentPage = useSelector(
    (state: RootState) => state.dashboard.currentPagePayment
  );
  const selectedAmountPayment = useSelector(
    (state: RootState) => state.multiBlPayment.selectedAmountPaymentAll
  );

  const data:any =  useSelector(
    (state: RootState) => state.dashboard.bulkpaymentDashboardList
  ); 

  const filterState = useSelector(
    (state: RootState) => state.dataTable.filterState
  );
  const selection = useSelector(
    (state: RootState) => state.multiBlPayment.selectedRowsInvoice
  );

  const grids = useSelector((state: RootState) => state.dataTable.bulkGrids);
  const [previousState, setPreviousState] = useState<{
    filterState: string | null;
    search: string | null;
    grids: any[] | null;
  }>({
    filterState: "{}",
    search: "",
    grids: grids?.[0]?.gridId,
  });
  const [currentState, setCurrentState] = useState<{
    filterState: string | null;
    search: string | null;
    grids: any[] | null;
  }>({
    filterState: "{}",
    search: "",
    grids: grids?.[0]?.gridId,
  });
  const profileDetails = useSelector(
    (state: RootState) => state.userProfile.profile
  );
  const sortState = useSelector(
    (state: RootState) => state.dataTable.sortState
  );
  const setCurrentPage = (page: number) => {
    dispatch(updateCurrentPagePayment(page));
  };
  const selectedRowsPayment = useSelector(
    (state: RootState) => state.multiBlPayment.selectedRowsPayment
  );

  const paymentTopSearchState = useSelector(
    (state: RootState) => state.navbarTop.paymentTopSearchState
  );
  const selectedConfigId = useSelector(
    (state: RootState) => state.dataTable.selectedConfigId
  );
  const selectedTopSearchFilter = useSelector(
    (state: RootState) => state.navbarTop.selectedTopSearchFilter
  );
  const searchInputValue = useSelector(
    (state: RootState) => state.navbarTop.searchInputValue
  );
  const rbac = useSelector((state: RootState) => state.userProfile);
  const dataCountry = useDataCountry();
  const linerId = useSelector((state: RootState) => state.navbarTop.linerId);
  const language = useSelector((state: RootState) => state.navbarTop.language);
  const selectionDisabledForLiner =
    profileDetails.partnerType?.toLowerCase() === "liner" ? false : true;
  function useDebouncedEffect(effect: any, deps: any, delay: any) {
    const callback = useRef<any>();

    useEffect(() => {
      callback.current = effect;
    }, [effect]);
    useEffect(() => {
      console.log("selectionInitialState", selectionInitialState);
    }, [selectionInitialState]);
    useEffect(() => {
      const handler = () => {
        if (callback.current) {
          callback.current();
        }
      };

      const timer = setTimeout(handler, delay);

      return () => clearTimeout(timer);
    }, [...deps, delay]);
  }
  var newselectedRowsPayment: any = [];
  useEffect(() => {
    console.log("selectedRowsPayment.length", selectedRowsPayment);
    // Directly filter selectedRowsPayment based on the 'Submitted' status
    newselectedRowsPayment = selectedAmountPayment
      .filter(
        (item: any) =>
          item.pmtmode && item.pmtstatus.toUpperCase() == "SUBMITTED"
      )
      .map((item: any) => item.pmtmode);

    console.log(
      "Filtered Payment Modes:",
      //selectedAmountPayment
      selectedAmountPayment.filter(
        (item: any) =>
          item && item.pmtmode && item.pmtstatus.toUpperCase() == "SUBMITTED"
      )

      //newselectedRowsPayment
    );
    const uniqueList = newselectedRowsPayment
      .filter((item: any) => item !== undefined && item !== null) // Remove undefined and null items
      .filter(
        (item: any, index: number, arr: any[]) => arr.indexOf(item) === index
      );
    dispatch(updateSelectedRowsPayment(uniqueList));
    console.log(
      "selectedrowslength",
      selectedRowsPayment,
      selectedRowsPayment.length
    );
  }, [selectedAmountPayment, dispatch, data]);
  useEffect(() => {
    if (
      selectedAmountPayment.length === 0 &&
      location.pathname.split("/")[0] === "bulkpaymentDashboard"
    ) {
      navigate(`/bulkpaymentDashboard${location.search}`);
    }
  }, [selectedAmountPayment]);
  const generateColumnConfig = useGenerateColumnConfig();

  useEffect(() => {
    const paymentDashboardDefinition = grids?.[0]?.columnConfigGrid || "";

    if (!paymentDashboardDefinition) return;

    try {
      const configs = generateColumnConfig(
        JSON.parse(JSON.parse(paymentDashboardDefinition)),
        getParams
      );

      const columns = configs?.columns?.map((c) => c);
      setConfigs(configs);
      setColumns(columns);
    } catch (e) {
      console.error("Column Error: ", e);
    }
  }, [grids, location]);

  useEffect(() => {
    dispatch(updateDashbaordName(gridName));
  }, []);

  const filterStateLocal = filterState?.["bulkpaymentTwo"];
  const sort = (queryString.parse(location.search)?.sort as string)
    ?.split?.(",")
    ?.join?.(" ");
  //   (profileDetails.partnerType === 'customer' &&
  //   profileDetails.partnerId &&
  //   grids?.[0]?.whereClause) ||
  // profileDetails.partnerType === 'liner'

  useEffect(() => {
    if (location?.pathname && dataCountry && linerId) {
      dispatch(
        getColumnViews({
          gridName: dashboardName,
          country: 'US',
          linerId: linerId,
          language: language || localStorage.getItem('selectedLanguage') || 'EN',
        })
      );
    }
    dispatch(updateParams({}));
    // dispatch(
    //   updateSortStateDataTable({
    //     key: null,
    //   })
    // );
  }, [dataCountry, linerId, grids, data, language]);

  useEffect(() => {
    loadPaymentDashboard(false);
  }, [currentPage]);
  const _onSelect = (data: any) => {
    // dispatch(updateSelectedBlListMultiPay([...selectedBlData,data.list]));
  };
  useEffect(() => {
    if (refresh) loadPaymentDashboard(false);
    // server sometimes takes time to update the view so the delay
    setTimeout(() => dispatch(updateDashbaordRefresh(false)), 2000);
  }, [refresh]);

  useEffect(() => {
    const currentState = {
      filterState: JSON.stringify(filterStateLocal),
      search: location.search,
      grids: grids?.[0]?.gridId,
    };
    if (JSON.stringify(previousState) !== JSON.stringify(currentState)) {
      setCurrentState({
        filterState: JSON.stringify(filterStateLocal),
        search: location.search,
        grids: grids?.[0]?.gridId,
      });
    }
  }, [filterStateLocal, location.search, grids]);

  // useEffect(() => {
  //   if (JSON.stringify(previousState) !== JSON.stringify(currentState)) {
  //     loadPaymentDashboard(true);
  //     setPreviousState(currentState);
  //   }
  // }, [currentState, linerId]);

  useDebouncedEffect(
    () => {
      if (JSON.stringify(previousState) !== JSON.stringify(currentState)) {
        loadPaymentDashboard(true);
        setPreviousState(currentState);
      }
    },
    [currentState, linerId, language],
    700
  );

  useEffect(() => {
    loadPaymentDashboard(true);
  }, [linerId, language]);

  const loadPaymentDashboard = (filterUpdated: boolean) => {
    if (!rbac?.rbacDetails) return;

    const hasAccess =
      rbac.rbacDetails.sendPaymentToLiner === "Y" ||
      rbac.rbacDetails.createMergePayment === "Y";

    if (!hasAccess) return;

    if (filterUpdated) setCurrentPage(1);

    const filterApiState: any = {};
    if (filterStateLocal && Object.keys(filterStateLocal).length > 0) {
      const filterKeys = Object.keys(filterStateLocal);
      for (let k of filterKeys) {
        const filterValue = filterStateLocal?.[k];
        console.log(`Processing filter key: ${k}`, filterValue);

        if (typeof filterValue === "object" && filterValue !== null && ('from' in filterValue || 'to' in filterValue)) {
          const fromVal = filterValue.from;
          const toVal = filterValue.to;
          console.log(`  fromVal: ${fromVal}, toVal: ${toVal}`);

          if (fromVal === "" && toVal === "") {
            filterApiState[k] = undefined;
            console.log(`  Filter ${k} set to undefined (both empty)`);
          } else if (fromVal != null || toVal != null) {
            filterApiState[k] = [fromVal, toVal];
            console.log(`  Filter ${k} set to:`, filterApiState[k]);
          } else {
            filterApiState[k] = undefined;
            console.log(`  Filter ${k} set to undefined (both null/undefined)`);
          }
        } else if (typeof filterValue === "string" && filterValue.trim() !== "") {
          filterApiState[k] = [filterValue];
          console.log(`  Filter ${k} set to (string):`, filterApiState[k]);
        } else if (Array.isArray(filterValue) && filterValue.length > 0) {
          filterApiState[k] = filterValue;
          console.log(`  Filter ${k} set to (array):`, filterApiState[k]);
        } else {
          filterApiState[k] = undefined;
          console.log(`  Filter ${k} set to undefined (other empty/invalid)`);
        }
      }
    }

    const finalFilterApiState: any = selectedTopSearchFilter?.id && searchInputValue.trim() != ''
      ? { [selectedTopSearchFilter?.id]: [searchInputValue.trim()] }
      : {};

    if (grids[0]) {
      let timeFlag = '';
      let timeDiff = 0;
      let dateRange: any = {};

      const newdata = grids[0].configGroup?.find(
        (c: any) => c.userGridId == selectedConfigId?.[gridName]
      )?.columnConfigGrid;
      if (newdata) {
        timeFlag = JSON.parse(newdata).find(
          (item: any) => item.accessor == 'invdt'
        )?.filterState;
        timeDiff = JSON.parse(newdata).find(
          (item: any) => item.accessor == 'invdt'
        )?.timeDiff;
        dateRange = JSON.parse(newdata).find(
          (item: any) => item.accessor == 'invdt'
        )?.dateRange;
      }
      if (filterApiState.invdt && timeFlag == 'day' && dateRange) {
        filterApiState.invdt[1] = moment()
          .subtract(Math.abs(dateRange.to), 'days')
          .endOf('day')
          .toISOString();
        filterApiState.invdt[0] = moment()
          .subtract(Math.abs(dateRange.from), 'days')
          .startOf('day')
          .toISOString();
      }
    }

    for (let i of Object.keys(filterApiState)) {
      if (filterApiState[i] !== undefined) {
        finalFilterApiState[i] = filterApiState[i];
      }
    }

    if (
      (profileDetails.partnerType === 'customer' && profileDetails.partnerId) ||
      profileDetails.partnerType === 'liner'
    ) {
      setTimeout(() => {
        dispatch(
          getDashboardData({
            gridName: gridName,
            payload: {
              fields: [],
              filters: finalFilterApiState,
              size: 20,
              sorts:
                sortState && sortState?.key != null && sortState?.value != null
                  ? [`${sortState?.key} ${sortState?.value}`]
                  : sort
                    ? [sort]
                    : ["bulk_payment_process_config_id desc"],
              page: filterUpdated ? 1 : currentPage,
            },
            dataCountry: dataCountry,
            partnerId:
              profileDetails.partnerType === 'customer'
                ? profileDetails.partnerId
                : null,
            where: grids?.[0]?.whereClause
              ? AESEncrypt(grids?.[0]?.whereClause)
              : null,
            parameter:
              selectedTopSearchFilter?.where !== ''
                ? {
                    searchParameter: searchInputValue,
                    searchWhere: selectedTopSearchFilter?.where,
                  }
                : {},
          })
        );
      }, 250);
    }
  };

  const showColumnSettings = useSelector(
    (state: RootState) => state.paymentDashboard.showColumnSettings
  );

  const getParams = () => {
    return {
      blid: blNum ? AESDecrypt(blNum) : "",
      pmtmode: blNum ? AESDecrypt(blNum) : "",
    };
  };

  useEffect(() => {
    dispatch(updateParams({}));
    dispatch(
      updateSortStateDataTable({
        key: null,
      })
    );
  }, [dataCountry]);
  useEffect(() => {
    console.log("selectedRowsPayment.lengthinside", selectedRowsPayment);
  }, [selectedRowsPayment]);

  useEffect(() => {
    console.log("selectedRowsPayment", selectedRowsPayment.length);
  }, [selectedRowsPayment]);
  const prevSelectionsRef = useRef<any>(null); // to store previous selections

  useEffect(() => {
    const selections: any = {};

    data.result?.forEach((d:any, i:any) => {
      if (
        selectedRowsPayment.includes(d.pmtmode) &&
        !d?.paymentRefNo &&
        !(d?.paidIndicator === "1")
      )
        selections[i] = true;
    });

    // Dispatch updated selections for the table
    dispatch(updateSelectedpaymentMultiPayTable(selections));
  }, [selectedRowsPayment, data]);

  const sideWidth =
    Object.entries({
      [`/bulkpaymentDashboard`]: 0,
      [`/blsliderpayment/:blNum`]: 6,
    }).find(([path, _]) => matchPath(path, location.pathname))?.[1] ?? 9;

  return (
    <>
      <DashboardContainer
        sideWidth={sideWidth}
        middleChildren={
          location.pathname.split("/")[1] == "bulkpayment" ? (
            <OblDetails
              blslider={`/blsliderinvoice/${location.pathname.split("/")[1]}`}
            />
          ) : (
            <div className={`flex-1 h-100 smoothDiv w-100`}>
              <Outlet />
            </div>
          )
        } 
      >
        <FilterView
          loadList={loadPaymentDashboard}
          showUploadButton
          showExport={true}
          showColumnSettings={true}
          dataLoading={false}
              toggleColumnSettings={toggleColumnSettingsPayDash}
         columnSettingsPersistKey="@odex/paydash/v1"
          uniqueFilterKey="bulkpaymentTwo"
        //  child={<div>{FilterViewChild}</div>}
          configViews={
            grids?.find?.((g: any) => g?.gridName === dashboardName)
              ?.configGroup || []
          }
          // child={resendButton}
         showRightDiv={!!matchPath(location.pathname, "/bulkpaymentDashboard")}
          dashboardName={dashboardName}
       
          data={data}
          gridDef={grids}
        />
        {columns?.length > 0 && (
          <DataTable
            data={data?.result || null}
            columns={columns}
               showColumnSettings={showColumnSettings}
                     
                      
            dataCountry={dataCountry || ""}
            sortable
            searchable={false}
            showColumnFilter={true}
            selection={
           /*    rbac.rbacDetails.sendPaymentToLiner == "Y" ||
              rbac.rbacDetails.createMergePayment == "Y"
                ? true
                : */ false
            }
            onCustomSelectChange={_onSelect}
            selectionInitialState={selectionInitialState}
            disableRowSelection={{
              accessor: "payment",
              value: "Paid",
            }}
          /*   onSelectRow={(dat) => {
              if (dat?.action === "add") {
                if (dat?.data?.length > 0) {
                  dispatch(
                    updateSelectedRowsPayment([
                      ...selectedRowsPayment,
                      ...dat?.data?.map((d: any) => d.pmtmode),
                    ])
                  );
                } else {
                  dispatch(
                    updateSelectedRowsPayment([
                      ...selectedRowsPayment,
                      dat?.data?.pmtmode,
                    ])
                  );
                }
              } else {
                if (dat?.data?.length > 0) {
                  dispatch(
                    updateSelectedRowsPayment(
                      selectedRowsPayment.filter(
                        (f: any) =>
                          !dat?.data?.map((v: any) => v?.pmtmode).includes(f)
                      )
                    )
                  );
                } else {
                  dispatch(
                    updateSelectedRowsPayment(
                      selectedRowsPayment.filter(
                        (f: any) => f !== dat?.data?.pmtmode
                      )
                    )
                  );
                }
              }
            }}
            clearSelection={() => {
              dispatch(updateSelectedpaymentMultiPayTable({}));
            }} */
            onHide={() => {
                        dispatch(toggleColumnSettingsPayDash(false));
                      }}
            perPage={20}
            pagination
            numberPagination
            maxPage={parseInt(data?.maxPage || "100")}
            hasNext={data?.hasNext}
            currentPage={currentPage}
            gridId={grids?.[0]?.gridId || 0}
            onChangePageNumber={(pageNumber) => setCurrentPage(pageNumber)}
            showExport={false}
           
       
            columnSettingsPersistKey="@odex/paydash/v1"
            customSort={true}
            uniqueFilterKey="bulkpaymentTwo" //"paymentTwo"""
            staticHiddenCols={[
              ...(rbac.rbacDetails.sendPaymentToLiner == "Y"
                ? []
                : ["to_liner_time", "to_liner_email"]),
              ...(rbac.rbacDetails.revisitPayment == "Y"
                ? []
                : ["revisit_time", "revisit_email"]),
              ...(rbac.rbacDetails.paymentDashboardRemarks == "Y"
                ? []
                : ["user_remarks"]),
              ...(configs?.staticHiddenCols ?? []),
            ]}
            defaultHiddenCols={[
            
            ]}
            tableMinHeight={300}
            gridName={dashboardName}
            dataLoading={false}
            configGroup={grids?.[0]?.configGroup || []}
          />
        )}
      </DashboardContainer>
    </>
  );
};

export default BulkPaymentDashboard;
